import { render } from "./warnings.vue?vue&type=template&id=08cbc783&scoped=true"
import script from "./warnings.vue?vue&type=script&lang=js"
export * from "./warnings.vue?vue&type=script&lang=js"

import "./warnings.vue?vue&type=style&index=0&id=08cbc783&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cbc783"]])

export default __exports__